const arrayIsNotEmpty = array =>
  array && Array.isArray(array) && array.length > 0

export default arrayIsNotEmpty



// WEBPACK FOOTER //
// ./src/utility/arrayIsNotEmpty.js